export default __webpack_public_path__ + "783b2af3194e53dd33f7382191b8ef23.png";